<app-navigation></app-navigation>
<app-maintenance></app-maintenance>
<div class="mainContentFullWith unselectable">
<div class="unselectable headerTitle headline">Stammdatenverwaltung</div>
<div class="breakLine"></div>
<div id="moduleContent">
<mat-tab-group>
<mat-tab label="Mitarbeiter">
  <div class="matTabContent">
    <ejs-grid
      #employeeGrid
      id="employeeGrid"
      [dataSource]="employeeDataSource"
      [columns]="employeeColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="employeeActionBegin($event)">
    </ejs-grid>
    <ng-template #employeeDialog class="dialog">
      <h2 matDialogTitle>{{employee.FirstName}} {{employee.LastName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>Id</mat-label>
          <input name="carTypeId" matInput type="number" [(ngModel)]="employee.UniqueId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>Vorname</mat-label>
          <input name="firstName" matInput type="text" [(ngModel)]="employee.FirstName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>Nachname</mat-label>
          <input name="lastName" matInput type="text" [(ngModel)]="employee.LastName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>UserName</mat-label>
          <input name="userName" matInput type="text" [(ngModel)]="employee.UserName">
        </mat-form-field>
        <div class="checkBoxContent">
          <mat-checkbox name="isActive" [(ngModel)]="employee.IsActive" [checked]="employee.IsActive" color="primary">Aktiv</mat-checkbox>
          <mat-checkbox name="IsWebUser" [(ngModel)]="employee.IsWebUser" [checked]="employee.IsWebUser" color="primary">WebUser</mat-checkbox>
          <mat-checkbox name="IsAdministrator" [(ngModel)]="employee.IsAdministrator" [checked]="employee.IsAdministrator" color="primary">Administrator</mat-checkbox>
        </div>
        <mat-form-field class="formField">
          <mat-label>Passwort</mat-label>
          <input name="password" matInput type="text" [(ngModel)]="employee.Password">
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveEmployee()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
<mat-tab label="Fahrzeug Modelle">
  <div class="matTabContent">
    <ejs-grid
      #carTypeGrid
      id="carTypeGrid"
      [dataSource]="carTypeDataSource"
      [columns]="carTypeColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="carTypeActionBegin($event)">
    </ejs-grid>
    <ng-template #carTypeDialog class="dialog">
      <h2 matDialogTitle>{{carType.CarTypeName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>CarTypeId</mat-label>
          <input name="carTypeId" matInput type="number" [(ngModel)]="carType.CarTypeId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>CarTypeName</mat-label>
          <input name="carTypeName" matInput type="text" [(ngModel)]="carType.CarTypeName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-select name="carBrand" [(ngModel)]="carType.CarBrandId" [compareWith]="carBrandComparisonFunction" placeholder="CarBrandName">
            <mat-option *ngFor="let carBrand of carBrandDataSource" [value]="carBrand.CarBrandId">{{carBrand.CarBrandName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveCarType()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
<mat-tab label="Fahrzeug Marke">
  <div class="matTabContent">
    <ejs-grid
      #carBrandGrid
      id="carBrandGrid"
      [dataSource]="carBrandDataSource"
      [columns]="carBrandColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="carBrandActionBegin($event)">
    </ejs-grid>
    <ng-template #carBrandDialog class="dialog">
      <h2 matDialogTitle>{{carBrand.CarBrandName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>CarBrandId</mat-label>
          <input name="carBrandId" matInput type="number" [(ngModel)]="carBrand.CarBrandId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>CarBrandName</mat-label>
          <input name="carBrandName" matInput type="text" [(ngModel)]="carBrand.CarBrandName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-select name="importer" [(ngModel)]="carBrand.ImporterId" [compareWith]="importerComparisonFunction" placeholder="ImporterName">
            <mat-option *ngFor="let importer of importerDataSource" [value]="importer.ImporterId">{{importer.ImporterName}}</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveCarBrand()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
<mat-tab label="Importeur">
  <div class="matTabContent">
    <ejs-grid
      #importerGrid
      id="importerGrid"
      [dataSource]="importerDataSource"
      [columns]="importerColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="importerActionBegin($event)">
    </ejs-grid>
    <ng-template #importerDialog class="dialog">
      <h2 matDialogTitle>{{importer.ImporterName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>ImporterId</mat-label>
          <input name="importerId" matInput type="number" [(ngModel)]="importer.ImporterId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>ImporterName</mat-label>
          <input name="importerName" matInput type="text" [(ngModel)]="importer.ImporterName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>ImporterTransitId</mat-label>
          <input name="importerTransitId" matInput type="text" [(ngModel)]="importer.ImporterTransitId">
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveImporter()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
<mat-tab label="Versicherungsart">
  <div class="matTabContent">
    <ejs-grid
      #insuranceGrid
      id="insuranceGrid"
      [dataSource]="insuranceDataSource"
      [columns]="insuranceColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="insuranceActionBegin($event)">
    </ejs-grid>
    <ng-template #insuranceDialog class="dialog">
      <h2 matDialogTitle>{{insurance.InsuranceName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>InsuranceId</mat-label>
          <input name="insuranceId" matInput type="number" [(ngModel)]="insurance.InsuranceId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>InsuranceName</mat-label>
          <input name="insuranceName" matInput type="text" [(ngModel)]="insurance.InsuranceName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>PoliceNo</mat-label>
          <input name="policeNo" matInput type="text" [(ngModel)]="insurance.PoliceNo">
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveInsurance()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
<mat-tab label="Auftragstyp">
  <div class="matTabContent">
    <ejs-grid
      #jobTypeGrid
      id="jobTypeGrid"
      [dataSource]="jobTypeDataSource"
      [columns]="jobTypeColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="jobTypeActionBegin($event)">
    </ejs-grid>
    <ng-template #jobTypeDialog class="dialog">
      <h2 matDialogTitle>{{jobType.JobTypeName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>JobTypeId</mat-label>
          <input name="jobTypeId" matInput type="number" [(ngModel)]="jobType.JobTypeId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>JobTypeName</mat-label>
          <input name="jobTypeName" matInput type="text" [(ngModel)]="jobType.JobTypeName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>SqlSelect</mat-label>
          <input name="sqlSelect" matInput type="text" [(ngModel)]="jobType.SqlSelect">
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveJobType()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
<mat-tab label="Empfänger/Absender/Rep. Werkstatt">
  <div class="matTabContent">
    <ejs-grid
      #receiverGrid
      id="receiverGrid"
      [dataSource]="receiverDataSource"
      [columns]="receiverColumns"
      [editSettings]="editSettings"
      [toolbar]="toolbar"
      [allowPaging]="allowances"
      [pageSettings]="allowances"
      [allowExcelExport]="allowances"
      [allowPdfExport]="allowances"
      (toolbarClick)="toolbarClick($event)"
      (actionBegin)="receiverActionBegin($event)">
    </ejs-grid>
    <ng-template #receiverDialog class="dialog">
      <h2 matDialogTitle>{{receiver.ReceiverName}}</h2>
      <form class="dialogContent">
        <mat-form-field class="formField">
          <mat-label>ReceiverId</mat-label>
          <input name="receiverId" matInput type="number" [(ngModel)]="receiver.ReceiverId" [readonly]="readonly">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>ReceiverName</mat-label>
          <input name="receiverName" matInput type="text" [(ngModel)]="receiver.ReceiverName">
        </mat-form-field>
        <mat-form-field class="formField">
          <mat-label>Receiver_Id_Transit</mat-label>
          <input name="receiver_Id_Transit" matInput type="text" [(ngModel)]="receiver.Receiver_Id_Transit">
        </mat-form-field>
      </form>
      <mat-dialog-actions class="justify-content-between">
        <button mat-button class="customButtons" (click)="cancel()">Abbrechen</button>
        <button mat-button class="customButtons" (click)="saveReceiver()">Speichern</button>
      </mat-dialog-actions>
    </ng-template>
  </div>
</mat-tab>
</mat-tab-group>
</div>
</div>
<app-footer></app-footer>
